<template>
  <el-dialog
    :visible.sync="visibleProxy"
    title="Lịch sử sử dụng gói giới hạn"
    width="820px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="ps-dialog"
  >
    <div v-if="schoolRow" class="ps-history-header">
      <div>
        <span class="ps-history-header__eyebrow">Lịch sử áp dụng gói</span>
        <h3>{{ schoolRow.school.name }}</h3>
        <p>Trường {{ schoolRow.school.id }} · {{ histories.length }} lần áp dụng</p>
      </div>
      <div class="ps-history-total">
        <span>Gói hiện tại</span>
        <strong>{{ currentPackageCode }}</strong>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="histories"
      border
      class="sk-table ps-table ps-history-table"
      size="small"
      empty-text="Chưa có lịch sử sử dụng gói"
    >
      <el-table-column label="Gói áp dụng" min-width="200">
        <template slot-scope="{ row }">
          <span class="ps-package-code">{{ row.packageCode || "—" }}</span>
          <span class="ps-package-cell__base">{{ row.packageName || "Không xác định" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Ngày áp dụng" width="145" align="center">
        <template slot-scope="{ row }">
          {{ row.assignedAt | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label="Ngày kết thúc" width="145" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.endedAt">{{ row.endedAt | formatDate }}</span>
          <span v-else class="ps-row-muted">Đang sử dụng</span>
        </template>
      </el-table-column>
      <el-table-column label="Giới hạn" width="105" align="center">
        <template slot-scope="{ row }">
          {{ row.effectiveLimit | formatNumber }} HS
        </template>
      </el-table-column>
      <el-table-column label="Số lượng thêm" width="115" align="center">
        <template slot-scope="{ row }">
          <span class="ps-addon-amount">+{{ row.addonTotal | formatNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Trạng thái" width="120" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="statusType(row)" size="mini" effect="light">
            {{ statusLabel(row) }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="ps-dialog-footer">
      <el-button type="primary" @click="visibleProxy = false">Đóng</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "PackageUsageHistoryDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    schoolRow: {
      type: Object,
      default: null,
    },
    histories: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    currentPackageCode() {
      return this.schoolRow && this.schoolRow.package
        ? this.schoolRow.package.code || "Đang sử dụng"
        : "Chưa gán";
    },
  },
  methods: {
    statusType(row) {
      return row.status === "active" ? "success" : "info";
    },
    statusLabel(row) {
      return row.status === "active" ? "Đang sử dụng" : "Đã kết thúc";
    },
  },
};
</script>
